export type DayMode = "blocked" | "shopping" | "marketplace" | "personal";
export type BudgetCategory = {
  id: number;
  name: string;
  limit: number;
  spent: number;
  color: string;
};
export type DayPlan = { date: string; weekday: string; number: number; mode: DayMode };

export const formatDateKey = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const initialCategories: BudgetCategory[] = [
  { id: 1, name: "Продукты", limit: 4000, spent: 2140, color: "#ef9f48" },
  { id: 2, name: "Бензин", limit: 1500, spent: 650, color: "#68a18c" },
  { id: 3, name: "Дом и быт", limit: 1000, spent: 420, color: "#8b82c1" },
];
const demoModes: DayMode[] = [
  "blocked",
  "personal",
  "shopping",
  "blocked",
  "marketplace",
  "personal",
  "blocked",
];

export const getCurrentWeekDays = (today = new Date()): DayPlan[] => {
  const monday = new Date(today);
  const dayOfWeek = monday.getDay() || 7;
  monday.setDate(monday.getDate() - dayOfWeek + 1);
  const weekdays = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

  return weekdays.map((weekday, index) => {
    const date = new Date(monday);
    date.setDate(monday.getDate() + index);
    return {
      date: formatDateKey(date),
      weekday,
      number: date.getDate(),
      mode: demoModes[index],
    };
  });
};

export const formatWeekRange = (days: DayPlan[]) => {
  const first = new Date(`${days[0].date}T12:00:00`);
  const last = new Date(`${days[days.length - 1].date}T12:00:00`);
  const formatMonth = new Intl.DateTimeFormat("ru-RU", { month: "long" });
  const firstMonth = formatMonth.format(first);
  const lastMonth = formatMonth.format(last);
  return firstMonth === lastMonth
    ? `${first.getDate()} — ${last.getDate()} ${lastMonth}`
    : `${first.getDate()} ${firstMonth} — ${last.getDate()} ${lastMonth}`;
};
export const modeLabels: Record<DayMode, string> = {
  blocked: "Не тратить",
  shopping: "Закупки",
  marketplace: "Маркетплейс",
  personal: "Личные траты",
};
export const formatMoney = (amount: number) => `${new Intl.NumberFormat("ru-RU").format(amount)} ₽`;
export const spentTotal = (items: BudgetCategory[]) =>
  items.reduce((total, item) => total + item.spent, 0);
export const limitTotal = (items: BudgetCategory[]) =>
  items.reduce((total, item) => total + item.limit, 0);
